var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "function-card" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#blockModal",
          },
          on: {
            click: function ($event) {
              return _vm.blockModal({ action: "add" })
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.changePage },
            scopedSlots: _vm._u([
              {
                key: "sort",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "text-center" }, [
                      scope.row.id !== 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort(scope.row.Guid, "up")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-long-arrow-alt-up",
                              }),
                            ]
                          )
                        : _vm._e(),
                      scope.row.id !== _vm.rows.length
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort(scope.row.Guid, "down")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-long-arrow-alt-down",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "edit",
                fn: function (scope) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        staticStyle: { "margin-right": "0.5rem" },
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#blockModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.blockModal({
                              action: "edit",
                              data: scope.row,
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "delete",
                fn: function (scope) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#delBlockModal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.block = scope.row
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "blockModal",
          tabindex: "-1",
          "aria-hidden": "true",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
          [
            _c("ValidationObserver", {
              ref: "block",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-content" }, [
                            _c("div", { staticClass: "modal-header" }, [
                              _c("span", { staticClass: "modal-title" }, [
                                _vm.action === "add"
                                  ? _c("span", [_vm._v("新增")])
                                  : _c("span", [_vm._v("編輯")]),
                              ]),
                            ]),
                            _c("div", { staticClass: "modal-body" }, [
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "select-block-type",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(" 類型 "),
                                                ]
                                              ),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.block.Position,
                                                      expression:
                                                        "block.Position",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    id: "select-block-type",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        _vm.block,
                                                        "Position",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "無" } },
                                                    [_vm._v("僅文字")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "左" } },
                                                    [_vm._v("有圖片(左側)")]
                                                  ),
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "右" } },
                                                    [_vm._v("有圖片(右側)")]
                                                  ),
                                                ]
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "input-block-title",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(" 標題 "),
                                                ]
                                              ),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.block.Title,
                                                    expression: "block.Title",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  id: "input-block-title",
                                                  maxlength: "50",
                                                },
                                                domProps: {
                                                  value: _vm.block.Title,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.block,
                                                      "Title",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "input-block-content",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "mark" },
                                                    [_vm._v("*")]
                                                  ),
                                                  _vm._v(" 內容 "),
                                                ]
                                              ),
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.block.Content,
                                                    expression: "block.Content",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  id: "input-block-content",
                                                  rows: "18",
                                                  maxlength: "4000",
                                                },
                                                domProps: {
                                                  value: _vm.block.Content,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.block,
                                                      "Content",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm.block.Position === "左" ||
                              _vm.block.Position === "右"
                                ? _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _c("span", { staticClass: "mark" }, [
                                          _vm._v("*"),
                                        ]),
                                        _vm._v("圖片"),
                                      ]),
                                      _vm.blockPic
                                        ? _c("img", {
                                            staticClass: "form-control",
                                            staticStyle: {
                                              height: "360px",
                                              "margin-bottom": "10px",
                                            },
                                            attrs: {
                                              src: _vm.blockPic,
                                              alt: "",
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                          },
                                        },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v(
                                              "* 檔案限制：[檔名].jpg、[檔名].png"
                                            ),
                                          ]),
                                          _c("br"),
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("* 大小限制：5MB以下"),
                                          ]),
                                          _c("br"),
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("* 僅能選取一個檔案"),
                                          ]),
                                          _c("br"),
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v(
                                              "* 上傳前請確認是否符合格式"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("ValidationProvider", {
                                        ref: "Pic",
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      ref: "uploadPic",
                                                      staticClass:
                                                        "upload-demo",
                                                      attrs: {
                                                        action: "",
                                                        accept:
                                                          "image/jpeg,image/png",
                                                        limit: 1,
                                                        "auto-upload": false,
                                                        "list-type": "picture",
                                                        "on-change":
                                                          _vm.uploadFile,
                                                        "on-remove":
                                                          _vm.removeFile,
                                                      },
                                                      model: {
                                                        value: _vm.block.Pic,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.block,
                                                            "Pic",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "block.Pic",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "small",
                                                            type: "primary",
                                                          },
                                                        },
                                                        [_vm._v(" 點擊上傳 ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    type: "button",
                                    "data-dismiss": "modal",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.block.Pic
                                        ? _vm.$refs.uploadPic.clearFiles()
                                        : null
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n("Buttons.Cancel")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.saveBlock)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "delBlockModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [_vm._v("刪除")]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除 "),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.block.Title))]
              ),
              _vm._v(" ? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delBlock },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }